// Module
var code = "<div class=\"br-caption-2\" ng-class=\"$ctrl.status\"> <md-tooltip md-delay=\"300\"> {{$ctrl.status | translate}} </md-tooltip> </div> ";
// Exports
export default code;